import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Hidden } from "@material-ui/core";
import fontConfig from "../../constants/fonts";

import TitleContainer from "./TitleContainer";
import UseMobile from "../../hooks/useIsMobile";
import LayoutContainer from "../../components/LayoutsContainer";
import IconItem from "./IconItem";
import MobileHidden from "../../components/Common/Hidden/MobileHidden";
import DesktopHidden from "../../components/Common/Hidden/DesktopHidden";
const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  root: {
    paddingTop: theme.spacing(2),

    paddingBottom: theme.spacing(3),
    // backgroundColor: theme.palette.primary.lightGray,
    [theme.breakpoints.only("md")]: {
      // height: "100%",
      paddingTop: theme.spacing(5),

      // paddingBottom: theme.spacing(0),
    },
    [theme.breakpoints.only("xs" || "sm")]: {
      // height: "100%",
      paddingTop: theme.spacing(5),

      // paddingBottom: theme.spacing(0),
    },
  },
  Divider: {
    marginBottom: theme.spacing(5),
    [theme.breakpoints.only("xs" || "sm")]: {},
  },
  titleContainer: {
    [theme.breakpoints.only("xs" || "sm")]: {
      // backgroundColor: "yellow",
    },
  },
  title: {
    ...fontConfig.bold,
    fontSize: "2rem",
    color: "white",
    backgroundColor: theme.palette.primary.main,
    // awidth: "20%",
    // width: "15%",
    textAlign: "center",
    padding: 10,
    // padding: "10 30px",
    // wordWrap: "no-wrap",
  },
  personalityContainer: {
    marginTop: theme.spacing(3),
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  CarouselProvider: {
    marginTop: theme.spacing(5),
    [theme.breakpoints.only("xs" || "sm")]: {
      marginTop: theme.spacing(2),
      // backgroundColor: "red",
    },
  },
  btns: {
    backgroundColor: "transparent",
    border: "none",
  },
  gridContainer: {
    // backgroundColor: "red",
    width: "100%",
    backgroundColor: theme.palette.lightGray,
  },
  iconContainer: {
    marginTop: theme.spacing(2),
  },
}));

const PortFolio = ({ data }) => {
  const classes = useStyles();
  const isMobile = UseMobile();

  return (
    <div className={classes.container}>
      <LayoutContainer>
        <div className={classes.root}>
          <Grid container>
            <Grid item lg={10} md={10} xs={12} sm={12}>
              {data.title && (
                <>
                  <MobileHidden>
                    <Grid container className={classes.gridContainer}>
                      <Grid item className={classes.titleContainer}>
                        <TitleContainer title={data.title} />
                      </Grid>
                    </Grid>
                  </MobileHidden>
                  <DesktopHidden>
                    <Grid
                      container
                      justify="center"
                      className={classes.gridContainer}
                    >
                      <Grid item className={classes.titleContainer}>
                        <TitleContainer title={data.title} />
                      </Grid>
                    </Grid>
                  </DesktopHidden>
                </>
              )}
            </Grid>
          </Grid>
          <Grid
            container
            spacing={isMobile ? 1 : 1}
            className={classes.iconContainer}
          >
            {data.data.map((man, index) => {
              return <IconItem key={index} data={man} />;
            })}
          </Grid>
        </div>
      </LayoutContainer>
    </div>
  );
};
export default PortFolio;
